import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import TextareaInput from '../../common/TextareaInput'; // Assuming the file location

const TextareaInputComponent = () => {
    return (
        <div className="page-content components">
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Textarea Input Showcase</h2>

                        {/* First Row - Required Textarea */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <TextareaInput
                                    label="Required Text Area"
                                    required={true}
                                    placeholder="Enter required text"
                                    maxLength={300}
                                    helpText="This field is required."
                                    showHelp={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<TextareaInput
    label="Required Text Area"
    required={true}
    placeholder="Enter required text"
    maxLength={300}
    helpText="This field is required."
    showHelp={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row - Optional Textarea */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <TextareaInput
                                    label="Optional Text Area"
                                    required={false}
                                    placeholder="Enter optional text"
                                    maxLength={200}
                                    showHelp={true}
                                    helpText="This is optional, you can leave it blank."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<TextareaInput
    label="Optional Text Area"
    required={false}
    placeholder="Enter optional text"
    maxLength={200}
    showHelp={true}
    helpText="This is optional, you can leave it blank."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row - Textarea with Custom Max Length */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <TextareaInput
                                    label="Textarea with Custom Max Length"
                                    required={true}
                                    maxLength={100}
                                    placeholder="Max 100 characters"
                                    helpText="Enter text with up to 100 characters."
                                    showHelp={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<TextareaInput
    label="Textarea with Custom Max Length"
    required={true}
    maxLength={100}
    placeholder="Max 100 characters"
    helpText="Enter text with up to 100 characters."
    showHelp={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row - Non-Resizable Textarea */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <TextareaInput
                                    label="Non-Resizable Textarea"
                                    required={false}
                                    placeholder="Fixed size, cannot resize"
                                    maxLength={150}
                                    resizable={false}
                                    helpText="This textarea is not resizable."
                                    showHelp={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<TextareaInput
    label="Non-Resizable Textarea"
    required={false}
    placeholder="Fixed size, cannot resize"
    maxLength={150}
    resizable={false}
    helpText="This textarea is not resizable."
    showHelp={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default TextareaInputComponent;
